/* eslint-disable @typescript-eslint/triple-slash-reference */
/* eslint-disable no-undef */
export class ImageHandler {
  static getImageUrl(id: string): string {
    if (process.env.REACT_APP_PERSON_SERVICE_ENV) {
      return `${process.env.REACT_APP_PERSON_SERVICE_ENV}/get-profile-picture?id=${id}`;
    }
    return `/ImageHandler.ashx?id=${id}`;
  }
}
